import React, { Component } from 'react';
import './DateRangePicker.css';
import Validation from '../validation/Validation';
import Label from '../label/Label';
import Input from '../../inputs/input/Input';
import Divider from '../divider/Divider';
import PrimaryButton from '../primaryButton/PrimaryButton';
import FontIcon from '../fontIcon/FontIcon';
import RadioGroup from '../../inputs/radioGroup/RadioGroup';
import toasts from '../../utils/toasts';

let radioOptions = {
	'24': 'Last 24 hours',
	'168': 'Last 7 Days',
	'720': 'Last 30 days',
	sixMonths: 'Last 6 months',
	oneYear: 'Last year'
};
export default class DateRangePicker extends Component {
	constructor(props) {
		super(props);
		let value = this._defaultValue();
		let { startDate, endDate } = this._getDatesFromTimeRange(value);
		this.state = {
			value,
			valid: true,
			open: false,
			startDate,
			endDate,
			displayValue: radioOptions[this.props.value]
		};
	}

	componentDidMount = async () => {
		document.addEventListener('mousedown', this._checkForOutsideClick, false);
		document.addEventListener('touchstart', this._checkForOutsideClick, false);
	};

	componentWillUnmount() {
		document.removeEventListener('mousedown', this._checkForOutsideClick, false);
		document.removeEventListener('touchstart', this._checkForOutsideClick, false);
	}

	_checkForOutsideClick = (e) => {
		if (!this.element.contains(e.target)) {
			if (this.state.open) this._applyFilter();
		}
	};

	isValid = () => {
		let hasValue = false;
		if (this.state) {
			hasValue = !this._isEmpty(this.state.value);
		}
		let required = this.props.required;
		if (required && hasValue) {
			return true;
		} else if (!required) {
			return true;
		} else {
			this.setState({ valid: false });
			return false;
		}
	};

	_defaultValue = () => {
		if (this._isEmpty(this.props.value)) {
			return '';
		}
		return this.props.value;
	};

	_isEmpty = (value) => {
		if (value === null) return true;
		if (value === undefined) return true;
		if (value === '') return true;
		if (value === -1) return true;
		return false;
	};

	getValue = () => {
		return this.state.value;
	};

	onChange = (value) => {};

	_renderInvalidText = () => {
		if (!this.state.valid) {
			return <Validation />;
		}
	};

	_toggleOpen = () => {
		let open = !this.state.open;
		this.setState({ open });
	};

	_open = () => {
		if (this.state.open) return;
		this.setState({ open: true });
	};

	_classes = () => {
		let classes = 'g-date-range-picker  ' + (this.props.className || '');
		if (this.state.open) classes += ' open ';
		return classes;
	};

	_saveAndClearOptions = () => {
		return (
			<div className="save-and-clear">
				<Label blue bold medium-small />
				<PrimaryButton onClick={this._applyFilter}>Apply</PrimaryButton>
			</div>
		);
	};

	_applyFilter = () => {
		let { startDate, endDate } = this._getStartAndEndDate(this.state.startDate, this.state.endDate);
		if (startDate && !isValidDate(startDate)) {
			return toasts.show('invalid start date');
		}
		if (endDate && !isValidDate(endDate)) {
			return toasts.show('invalid end date');
		}
		if (this.props.onChange)
			this.props.onChange({
				startDate,
				endDate
			});

		this.setState({ open: false });
	};

	_datesValid = (startDate, endDate) => {};

	_getStartAndEndDate = (startShortDate, endShortDate) => {
		let startDate = '';
		if (startShortDate) {
			startDate = new Date(startShortDate);
			startDate.setDate(startDate.getDate() - 1);
		}
		let endDate = '';
		if (endShortDate) {
			endDate = new Date(endShortDate);
			endDate.setDate(endDate.getDate() + 1);
		}
		return { startDate, endDate };
	};

	_getDatesFromTimeRange = (value) => {
		let state = {};
		let displayValue = radioOptions[value];
		state.displayValue = displayValue;
		state.value = value;
		if (value == parseInt(value)) {
			state.startDate = formatShortDate(new Date(Date.now() - value * 1000 * 60 * 60));
		} else if (value == 'oneYear') {
			let aYearAgo = new Date();
			aYearAgo.setFullYear(aYearAgo.getFullYear() - 1);
			state.startDate = formatShortDate(aYearAgo);
		} else if (value == 'sixMonths') {
			let sixMonthAgo = new Date();
			sixMonthAgo.setMonth(sixMonthAgo.getMonth() - 6);
			state.startDate = formatShortDate(sixMonthAgo);
		}
		state.endDate = formatShortDate(new Date());
		return state;
	};

	timePeriodChange = (timePeriod) => {
		let displayValue = radioOptions[timePeriod];
		let { startDate, endDate, value } = this._getDatesFromTimeRange(timePeriod);
		this.setState({ startDate, endDate, value, displayValue });
	};

	setStartDate = (startDate) => {
		let displayValue = startDate + ' - ' + this.state.endDate;
		this.setState({ startDate, displayValue });
	};

	setEndDate = (endDate) => {
		let displayValue = this.state.startDate + ' - ' + endDate;
		this.setState({ endDate, displayValue });
	};

	_renderSelected = () => {
		return (
			<Label black-light autosize className="input-placeholder" onClick={this._open}>
				{this.state.displayValue || 'All Dates'}
			</Label>
		);
	};

	_renderOptions = () => {
		return (
			<div className="options">
				<div className="label-row">
					<Label medium-small bold black-light>
						From
					</Label>
					<Label medium-small bold black-light>
						To
					</Label>
				</div>
				<div className="input-row">
					<Input onChange={this.setStartDate} value={this.state.startDate} placeholder={'MM/DD/YYYY'} />
					<Input onChange={this.setEndDate} value={this.state.endDate} placeholder={'MM/DD/YYYY'} />
				</div>
				<Label medium-small bold black-light>
					Select a Time Period:
				</Label>
				<div className="option-scroll-container">
					<RadioGroup value={this.state.value} onChange={this.timePeriodChange} options={radioOptions} />
				</div>
				<Divider />
				{this._saveAndClearOptions()}
			</div>
		);
	};

	render() {
		return (
			<div tabIndex="0" ref={(ref) => (this.element = ref)} className={this._classes()} onClick={this._open}>
				{this._renderSelected()}
				{this._renderOptions()}
				<FontIcon name="icon-chevron-right" />
				{this._renderInvalidText()}
			</div>
		);
	}
}

let formatShortDate = (dt) => {
	if (!dt || !dt.getDate) return '';
	return dt.getMonth() + 1 + '/' + dt.getDate() + '/' + dt.getFullYear();
};

function isValidDate(d) {
	return d instanceof Date && !isNaN(d);
}



// WEBPACK FOOTER //
// ./src/components/dateRangePicker/DateRangePicker.jsx